<template>
  <scroller
    :on-refresh="refresh"
  >
    <NavButtonBar>
      <nav-button @action="$router.back()">
        <i class="fa-solid fa-angle-left" />
      </nav-button>
    </NavButtonBar>
    <h1 class="text-primary pb-50 mt-2">
      {{ $t('pages.deliveries.now.name') }}
    </h1>
    <h4> 🚚 {{ $t('pages.deliveries.name') }}</h4>

    <div class="pt-75 mb-3">
      <template v-if="error">
        <div
          class="mb-5 text-muted text-center d-flex flex-column px-3"
        >
          <h1 class="mt-3 mb-2">
            <i class="fa-regular fa-cloud-exclamation" />
          </h1>
          {{ $t('pages.deliveries.now.loading-error') }}

          <div>
            <TouchButton
              size="xs"
              class="mt-2"
              @action="refresh(() => {}, true)"
            >
              {{ $t('therms.retry') }}
            </TouchButton>
          </div>
        </div>
      </template>
      <template v-else>
        <template v-if="!isFetch">
          <div class="d-flex align-items-center justify-content-center my-5 py-2">
            <b-spinner
              variant="primary"
              style="width: 3rem; height: 3rem;"
            />
          </div>
        </template>
        <template v-else>
          <template
            v-if="has"
          >
            <p class="text-black-25 mt-0 mb-3 pb-50">
              {{
                lastPullFormat !== null ? $t('pages.deliveries.now.updated-at', { date: lastPullFormat }) : $t('therms.loading')
              }}
            </p>

            <app-collapse
              type="border"
              class="animate__animated animate__fadeInUp"
            >
              <app-collapse-delivery :list="sortedList" />
            </app-collapse>
          </template>
          <template v-else>
            <div class="mt-3 text-center px-50">
              <span style="font-size: 6.5em">
                🚧
              </span>
              <h7 class="mt-1">
                {{ $t('therms.no-delivery') }}
              </h7>
              <p class="text-black-50 mt-0 pb-50">
                {{ $t('pages.deliveries.now.no-data') }}
              </p>
              <div class="mb-2">
                <TouchButton
                  size="xs"
                  @action="$router.push({ name:ROUTE_NAME_NOW })"
                >
                  {{ $t('therms.go-back') }}
                </TouchButton>
              </div>
            </div>
          </template>
        </template>
      </template>
    </div>
  </scroller>
</template>

<script>
import NavButtonBar from '@core/layouts/components/app-navbar/NavButtonBar.vue'
import NavButton from '@core/layouts/components/app-navbar/NavButton.vue'
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import { BSpinner } from 'bootstrap-vue'
import { mapGetters } from 'vuex'
import TouchButton from '@core/components/touch-button/TouchButton.vue'
// eslint-disable-next-line import/no-cycle
import { NAME_NOW } from '@/router/routes/now'
import AppCollapseDelivery from '@/views/components/AppCollapseDelivery.vue'

export default {
  components: {
    AppCollapseDelivery,
    TouchButton,
    BSpinner,
    NavButtonBar,
    NavButton,
    AppCollapse,
  },
  data() {
    return {
      // ui
      error: false,
    }
  },
  computed: {
    ...mapGetters({
      list: 'shipmentsNowDeliveries/getList',
      has: 'shipmentsNowDeliveries/has',
      count: 'shipmentsNowDeliveries/count',
      isFetch: 'shipmentsNowDeliveries/isFetch',
      lastPull: 'shipmentsNowDeliveries/getLastPull',
      hasMultipleFarmers: 'farmers/hasMultipleFarmers',
    }),
    ROUTE_NAME_NOW() {
      return NAME_NOW
    },
    /**
     * @returns {string|null}
     */
    lastPullFormat() {
      if (!this.lastPull) return null
      return (`${this.lastPull?.format('LT')}`).toLowerCase()
    },
    sortedList() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.list
        .sort((a, b) => new Date(b.datetime) - new Date(a.datetime))
    },
  },
  async mounted() {
    this.error = false

    this.emitter.on('appStateChange', async isActive => {
      if (this.needFetch(isActive)) await this.fetch(true)
    })

    try {
      if (this.needFetch(true)) await this.fetch(true)
    } catch (err) {
      this.error = true
      throw err
    }
  },
  beforeDestroy() {
    this.emitter.off('appStateChange')
  },
  methods: {
    needFetch(isActive = false) {
      if (this.$store.getters['shipmentsNowDeliveries/getLastPull'] === null) return true

      return (isActive && (this.$store.getters['shipmentsNowDeliveries/getLastPull']
        .locale('en')
        .format('YYYY-MM-DD') !== this.$moment()
        .locale('en')
        .format('YYYY-MM-DD')
          || this.$moment()
            .diff(this.$store.getters['shipmentsNowDeliveries/getLastPull'], 'minutes') >= 5))
    },
    /**
     * @param {Boolean} force
     */
    async fetch(force = false) {
      if (force) {
        this.$store.commit('shipmentsNowDeliveries/clear')
      }

      if (!this.$store.getters['shipmentsNowDeliveries/isFetch']) {
        await this.$store.dispatch('shipmentsNowDeliveries/fetch', true)
      }
    },
    /**
     * @param {Function} finishToRefresh
     * @param {Boolean} force
     * @returns {Promise<void>}
     */
    async refresh(finishToRefresh, force = false) {
      this.error = false

      try {
        if (force) this.$store.commit('shipmentsNowDeliveries/clear')
        await this.$store.dispatch('shipmentsNowDeliveries/fetch')
        finishToRefresh()
      } catch (err) {
        this.error = true
        finishToRefresh()

        throw err
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@core/scss/base/bootstrap-extended/_include';
@import '@core/scss/base/components/_include';

table tr td:nth-child(2) {
  padding-left: 20px;
}

</style>
